// src/pages/categories/CreateCategory.jsx

import React from "react";
import { useNavigate } from "react-router-dom";

import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditCategory from "../../components/categories/FormAddEditCategory";

const CreateCategory = () => {
    const navigate = useNavigate();

    const handleSuccess = () => {
        navigate("/categories");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditCategory
                isEdit={false}
                currentData={null}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default CreateCategory;
